var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("section", { staticClass: "content-tlist" }, [
        _c("table", { staticClass: "content-table" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.roles, function(role) {
              return _c("tr", [
                _c("td", [_vm._v(_vm._s(role.name))]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(_vm._s(role.group ? role.group.name : "(no group)"))
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      role.parent
                        ? (_vm.rolesById[role.parent] || {}).name
                        : "(no parent)"
                    )
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { href: "" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.editRole(role)
                        }
                      }
                    },
                    [_vm._v("Edit")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-danger",
                      attrs: { href: "" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.deleteRole(role)
                        }
                      }
                    },
                    [_vm._v("Delete")]
                  )
                ])
              ])
            }),
            0
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn btn-primary",
          attrs: { href: "" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.newRole()
            }
          }
        },
        [_vm._v("New Role")]
      ),
      _vm._v(" "),
      _vm.currentRole
        ? _c("role-edit", {
            attrs: { role: _vm.currentRole, roles: _vm.roles }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("td", [_vm._v("Role")]),
        _vm._v(" "),
        _c("td", [_vm._v("Group")]),
        _vm._v(" "),
        _c("td", [_vm._v("Parent")]),
        _vm._v(" "),
        _c("td", [_vm._v("Actions")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }